export const SCAN_CONSTANTS = {
  // Fast Domain check
  FAST_DOMAIN_CHECK_REQUEST: 'FAST_DOMAIN_CHECK_REQUEST',
  FAST_DOMAIN_CHECK_SUCCESS: 'FAST_DOMAIN_CHECK_SUCCESS',
  FAST_DOMAIN_CHECK_FAILURE: 'FAST_DOMAIN_CHECK_FAILURE',
  // Scans
  GET_SCANS_REQUEST: 'GET_SCANS_REQUEST',
  GET_SCANS_SUCCESS: 'GET_SCANS_SUCCESS',
  GET_SCANS_FAILURE: 'GET_SCANS_FAILURE',
  // OEM Scans
  GET_OEM_SCANS_REQUEST: 'GET_OEM_SCANS_REQUEST',
  GET_OEM_SCANS_SUCCESS: 'GET_OEM_SCANS_SUCCESS',
  GET_OEM_SCANS_FAILURE: 'GET_OEM_SCANS_FAILURE',
  RESET_SCAN_STATE: 'RESET_SCAN_STATE',
};